
const ContactTop = () => import("~/components/Car/ContactTop.vue");
const CarToolkit = () => import("~/components/Car/CarToolkit.vue");
export default {
  components: { ContactTop, CarToolkit },
  data() {
    return {};
  },
};
